import { useRef, useState } from "react";
import close from "../../../assets/images/model/close.svg";
import filePlus from "../../../assets/images/model/file-plus.svg";
const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;

const UploadBook = ({
  setSelectOption,
  setUploadBook,
  setUploadLoadingBook,
  setChosenFile,
  setLinkToFile,
  mode,
}) => {
  const formRef = useRef(null);
  const fileInput = useRef(null);
  const [err, setErr] = useState("");
  const [link, setLink] = useState("");
  const [fileChosen, setFileChosen] = useState(null);

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      const allowedTypes = ["application/msword", "application/pdf"];
      if (allowedTypes.includes(droppedFile.type)) {
        setFileChosen(droppedFile);
      } else {
        alert("Only .doc, .docx, and .pdf files are allowed.");
      }
    }
  };
  const handleUpload = () => {
    if (!fileChosen && !link) {
      setErr("Choose a file from your computer or provide a link to file.");
      return;
    } else if (link && !fileChosen) {
      if (!urlRegex.test(link)) {
        setErr("Link should be a valid url");
        return;
      }
    }
    setChosenFile(fileChosen);
    setLinkToFile(link);
    setUploadLoadingBook(true);
    setUploadBook(false);
  };

  // Function to prevent default behavior for file drop
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      <div
        className="modal custom_background custom_modal_create"
        id="upload_book"
        style={{ display: "block" }}
        tabIndex="-1"
        aria-labelledby="upload_bookLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <img
                  src={close}
                  alt="close"
                  onClick={() => {
                    if (mode !== "app") {
                      setSelectOption(false);
                    }
                    setUploadBook(false);
                  }}
                />
              </button>
            </div>
            <div className="modal-body-cre">
              <h4>upload a book</h4>
              <p>
                Drag and drop a PDF or word document file from your computer or
                add the URL of a website.
              </p>

              <div
                className="upload_book_inner my-40"
                onClick={() => {
                  fileInput.current.click();
                }}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
              >
                <div className="drag_and_drop_box" htmlFor="Drag-file">
                  <div className="upload_content">
                    <div className="icon-create mb-40">
                      <img src={filePlus} alt="upload" />
                    </div>
                    <div className="deflat_content" style={{ display: "none" }}>
                      <h6 className="f-size-18 theme__primary__text">
                        Drag and drop file, or <a href="">Browse</a>
                      </h6>
                      <p>Max size 1GB | Supports PDF or Word files</p>
                    </div>
                    <div
                      className="file_upload_content"
                      style={{ display: "block" }}
                    >
                      <p>
                        {fileChosen?.name}
                        {fileChosen ? (
                          <a
                            href=""
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();

                              setFileChosen(null);
                              formRef.current.reset();
                            }}
                          >
                            <img src={close} alt="close" />
                          </a>
                        ) : (
                          "No file chosen"
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                {/*  <div className="error_text error-create">
                    Oops, that file is too large to upload. Max file size is
                    1GB. Please try again.
                  </div> */}
              </div>
              <form ref={formRef}>
                <input
                  type="file"
                  ref={fileInput}
                  onChange={(e) => {
                    setErr("");
                    setFileChosen(e.target.files[0]);
                  }}
                  style={{ display: "none" }}
                  accept=".doc, .docx, application/pdf"
                />
              </form>

              <div className="input-link my-40">
                <div className="parent-graybar">
                  <div className="greybar"></div>
                  <span className="or-hr">OR</span>
                  <div className="greybar"></div>
                </div>
                <div className="link-text">
                  <input
                    className="link-input"
                    placeholder="Paste the link..."
                    type="url"
                    onChange={(e) => {
                      setErr("");
                      setLink(e.target.value);
                    }}
                  />
                </div>
              </div>
              {err && (
                <div
                  style={{
                    color: "red",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {err}
                </div>
              )}
              <div className="modal-btn">
                <button
                  type="button"
                  className="btn-black_create mb-24"
                  onClick={handleUpload}
                >
                  Upload book
                </button>
                <button
                  type="button"
                  className="btn-white-create"
                  onClick={() => {
                    setUploadBook(false);
                    setSelectOption(true);
                  }}
                >
                  Go back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadBook;
